import axios from "../../utils/axios";

const getDefaultState = () => {
    return {
        reports_data: null,
    }
}

const state = getDefaultState();

const getters = {
    reportsData: (state) => state.reports_data,
};

const actions = {
    async fetchReports({commit}, data) {
        const response = await axios.get(
            "/api/v1/navplus/sailink",
            {
                headers: {
                    Authorization: "Bearer" + data,
                },
            }
        );
        //console.log(response);
        commit("setReports", response.data.data.vessels.map((item, index) =>
            Object.assign(item, {index})
        ));
    },

    resetReportState({commit}) {
        commit("resetState");
    },


};

const mutations = {
    setReports: (state, reports) => (state.reports_data = reports),
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
